import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-wizard';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../limits-and-entitlements/limits-and-entitlements.component';
import './partials/positive-pay-ach-exceptions.component';
import './partials/positive-pay-check-exceptions.component';
import './partials/positive-pay-filter-rules.component';

@customElement('tm-bo-limits-and-entitlements-positive-pay')
export class PositivePay extends TmBaseComponent {
    @property()
    public companyId?: number;

    @property()
    public userId?: number;

    @state()
    private activeTabIndex = 0;

    public render() {
        return html` <tm-wizard
            .activeTabIndex=${this.activeTabIndex}
            .wizardMode=${false}
            @tab-change=${(e: CustomEvent) => (this.activeTabIndex = e.detail.index)}
        >
            <tm-bo-positive-pay-check-exception-permissions
                .companyId=${this.companyId}
                .userId=${this.userId}
            ></tm-bo-positive-pay-check-exception-permissions>
            <tm-bo-positive-pay-ach-exception-permissions
                .companyId=${this.companyId}
                .userId=${this.userId}
            ></tm-bo-positive-pay-ach-exception-permissions>
            <tm-bo-positive-pay-filter-rules-permissions
                .companyId=${this.companyId}
                .userId=${this.userId}
            ></tm-bo-positive-pay-filter-rules-permissions>
        </tm-wizard>`;
    }
}
